import React, { useState, Fragment } from 'react';

import { Title, GalleryContainer, CurrentContainer, CurrentImg, PreviewContainer, PreviewImg } from './styles.js';

export const Gallery = ({ gallery }) => {
	const [current, setCurrent] = useState(gallery[0]);

	return (
		<Fragment>
			<Title>MODELOS DISPONIBLES</Title>
			<GalleryContainer>
				<CurrentContainer>
					<CurrentImg src={current} alt="A lo Venezolano"/>
				</CurrentContainer>
				<PreviewContainer>
					{
						gallery.map((image, i) => {
							return <PreviewImg key={i} src={image} alt="A lo Venezolano" onClick={() =>setCurrent(gallery[i])} />
						})
					}
				</PreviewContainer>
			</GalleryContainer>
		</Fragment>
	)
};